module.exports = __webpack_public_path__ + "static/media/likhita.487e0a6f.png";